import { Box, Button, CircularProgress, Typography } from '@mui/material';
import ContractUploadSection from '~/pages/contract/newJourney/components/ContractUploadSection';
import type { ContractUploadFieldDef } from '~/pages/contract/newJourney/getContractUploadFields';
import type { TypeFile } from '~/pages/contract/step4/hooks/types';
import type { IFile } from '~/services/modules/contract/types';
import { RENEWAL_APP_IDS } from '../renewalAppIds';

type Props = {
  fields: ContractUploadFieldDef[];
  files: Partial<Record<TypeFile, IFile>>;
  errors: Partial<Record<TypeFile, boolean>>;
  sending: boolean;
  onChangeFile: (key: TypeFile, file: IFile) => void;
  onSubmit: () => void;
};

/**
 * Renovação fora do prazo (`is_renew_outdated` no `renew`): o pagamento já foi aprovado, mas a renovação só
 * conclui depois das fotos do equipamento. Substitui, no visual 2026, o envio de fotos legado (`/contract/file`)
 * e a tela de sucesso legada; os campos são os mesmos do passo 2 da contratação (`getContractUploadFields`).
 */
export default function RenewalPhotosStep({ fields, files, errors, sending, onChangeFile, onSubmit }: Props) {
  return (
    <Box
      data-app-id={RENEWAL_APP_IDS.stepPhotos}
      data-testid={RENEWAL_APP_IDS.stepPhotos}
      sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, textAlign: 'center', width: '100%' }}>
        <Typography component="h1" variant="h5">
          Envie as fotos do equipamento
        </Typography>
        <Typography sx={{ color: 'text.secondary' }} variant="body1">
          Seu pagamento foi aprovado. Como a renovação foi feita depois do fim da vigência, precisamos das fotos do
          equipamento para concluir.
        </Typography>
      </Box>

      <ContractUploadSection errors={errors} fields={fields} files={files} onChangeFile={onChangeFile} />

      <Button
        data-app-id={RENEWAL_APP_IDS.sendPhotos}
        disabled={sending}
        fullWidth
        onClick={onSubmit}
        size="large"
        startIcon={sending ? <CircularProgress aria-hidden color="inherit" size={18} /> : undefined}
        variant="contained"
      >
        {sending ? 'Enviando fotos' : 'Enviar fotos e concluir'}
      </Button>
    </Box>
  );
}
